<template>
  <div class="bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
    <div class="sm:mx-auto sm:w-full sm:max-w-md">
      <h2
        class="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900"
      >
        Authorization
      </h2>
      <p class="mt-2 text-center text-sm leading-5 text-gray-600 max-w">
        <a
          href="#"
          class="font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:underline transition ease-in-out duration-150"
        >
          Please, wait for the authorization to finish
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Authorization',
  created() {
    let token = this.$route.query.token
    delete this.$http.defaults.headers['api-token']
    this.$http
      .post('/api/v1/login_by_token', {
        token: token
      })
      .then((res) => {
        this.$store.dispatch('SET_USER', res.data)
        window.location.href = '/leads' // use this instead this.$router.push... to force reload the page
        // page reload is required to make sure that token will be added to every following api request
      })
      .catch((err) => {
        console.log(err)
        // todo: push to 'login' page. Example: this.$router.push({ name: 'login' })
      })
  }
}
</script>
